import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { useFormikContext } from 'formik';

import FormList from 'core/components/form-list';
import { AddInterestedPartyForm, InterestedParty } from 'common/components/people';
import useSession from 'core/hooks/use-session';
import { useDisabledState } from 'common/disabled-context';
import { Detail } from './detail';
import { SchedulePP } from 'common/components/schedule-pp';
import { Umbrella } from 'common/components/umbrella';
import { CondoCoverage } from './condo-coverage';
import { AutoInformation } from './auto-information';

function CondoOffer({ hasAuto }) {
  const { disabled } = useDisabledState();
  const { values } = useFormikContext();
  const {
    condoCoverage: { coverageX, coverageC },
    condo: {
      condoLocation: { state }
    }
  } = values;
  const { viewOnly } = useSession();

  const sppLimits = {
    tenPctOfCoverageC: coverageC * 0.1,
    fiftyPctOfCoverageC: coverageC * 0.5
  };

  return (
    <>
      <Detail disabled={disabled} />
      {!hasAuto && <AutoInformation disabled={disabled} />}
      <CondoCoverage disabled={disabled} />
      <SchedulePP disabled={disabled} sppLimits={sppLimits} />
      <FormList
        key={`parties-${disabled}`}
        id="interestedParties"
        item={InterestedParty}
        addForm={AddInterestedPartyForm}
        title="Additional interested party"
        addLabel="Add People"
        disabled={disabled || viewOnly}
      />
      <Umbrella disabled={disabled} coverageX={coverageX} state={state} />
    </>
  );
}

CondoOffer.propTypes = {
  hasAuto: PropTypes.bool.isRequired
};

export default observer(CondoOffer);
